export const MENU_SIDE_BAR_KEY = 'main.sideBarNav.v1';
